import { v4 as uuidv4 } from "uuid";
import type z from "zod";

export function isDateInRange(params: { date: Date; start?: Date; end?: Date; inclusive?: boolean }) {
    const epoch = params.date.getTime();
    const epochStart = params.start ? params.start.getTime() : -Infinity;
    const epochEnd = params.end ? params.end.getTime() : Infinity;

    // Default to inclusive if not specified
    const inclusive = params.inclusive ?? true;

    if (inclusive) {
        return epoch >= epochStart && epoch <= epochEnd;
    } else {
        return epoch > epochStart && epoch < epochEnd;
    }
}

export function getRandomKey(name?: string) {
    return `${name ? name : ""}${uuidv4()}`;
}

export function getBaseWindowURL() {
    return `${window.location.protocol}//${window.location.host}`;
}

export function safeParseJSON(str?: string) {
    if (!str) {
        return null;
    }
    try {
        return JSON.parse(str);
    } catch (e) {
        console.error(`Error while trying to parse JSON: ${e} -- raw string: ${str}`);
        return null;
    }
}

export function wait(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Takes an object and converts it's key/val pairs to search params.
 * This same logic is used in useRFQListFilter.tsx
 */
export function objectToQueryParams(obj: Record<string, any>): URLSearchParams {
    const params = new URLSearchParams();

    Object.entries(obj).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            // Skip undefined/null values
            return;
        } else if (Array.isArray(value)) {
            // Join arrays with commas
            if (value.length > 0) {
                params.set(key, value.join(","));
            }
        } else {
            // Convert everything else to string
            params.set(key, String(value));
        }
    });

    return params;
}

/**
 * Attempts to take a base64 string, decode it, parse it to JSON and then confirm it matches the schema.
 */
export function base64StringToSchema<T>(str: string | undefined, schema: z.ZodSchema<T>): T | null {
    try {
        if (!str) throw Error("Undefined string");
        const decoded = atob(str);
        const json = JSON.parse(decoded);
        return schema.parse(json);
    } catch (e) {
        return null;
    }
}
